var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 22L1.716 15.52H2.932L3.316 19.296L3.804 15.528H4.756L5.268 19.272L5.66 15.52H6.86L6.084 22H4.836L4.284 18.088L3.764 22H2.5ZM8.03813 22V15.52H10.9501V16.496H9.47013V18.104H10.5981V19.096H9.47013V21.032H10.9661V22H8.03813ZM12.0963 22V15.52H13.7843C14.0616 15.52 14.3229 15.5413 14.5683 15.584C14.8189 15.6267 15.0403 15.7093 15.2323 15.832C15.4243 15.9493 15.5736 16.12 15.6803 16.344C15.7923 16.5627 15.8483 16.8533 15.8483 17.216C15.8483 17.4773 15.8083 17.6987 15.7283 17.88C15.6536 18.056 15.5443 18.1973 15.4003 18.304C15.2616 18.4107 15.0936 18.4827 14.8963 18.52C15.1469 18.552 15.3576 18.6347 15.5283 18.768C15.6989 18.896 15.8269 19.0693 15.9123 19.288C16.0029 19.5067 16.0483 19.7707 16.0483 20.08C16.0483 20.416 16.0029 20.7067 15.9123 20.952C15.8269 21.192 15.7016 21.3893 15.5363 21.544C15.3709 21.6987 15.1656 21.8133 14.9203 21.888C14.6803 21.9627 14.4029 22 14.0883 22H12.0963ZM13.5283 21H13.8323C14.1469 21 14.3629 20.92 14.4803 20.76C14.6029 20.6 14.6643 20.3653 14.6643 20.056C14.6643 19.8107 14.6376 19.616 14.5843 19.472C14.5309 19.328 14.4429 19.224 14.3203 19.16C14.1976 19.0907 14.0323 19.056 13.8243 19.056H13.5283V21ZM13.5283 18.112H13.8083C14.0269 18.112 14.1923 18.08 14.3043 18.016C14.4163 17.9467 14.4909 17.848 14.5283 17.72C14.5709 17.592 14.5923 17.4373 14.5923 17.256C14.5923 17.0853 14.5603 16.944 14.4963 16.832C14.4376 16.7147 14.3469 16.6267 14.2243 16.568C14.1069 16.5093 13.9576 16.48 13.7763 16.48H13.5283V18.112ZM17.2554 22L17.3674 15.52H18.9034L19.6154 19.288L20.3834 15.52H21.8634L21.9754 22H20.9594L20.8394 17.688L20.0874 22H19.1834L18.3834 17.656L18.2874 22H17.2554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebm);
export default __webpack_public_path__ + "static/media/webm.2dc848c33eabd06d32265ea9aae62c47.svg";
export { ForwardRef as ReactComponent };